<script setup lang="ts">
import { Sex } from "@/enums/characterGeneratorEnums";
import { SheetDefinition } from "@/types/sheet-definiation";

const props = withDefaults(
  defineProps<{
    definition: SheetDefinition;
    isSelected: boolean;
    selectedSex: Sex;
    variantIdx?: number;
  }>(),
  {
    variantIdx: 0,
  }
);
</script>
<template>
  <div
    :aria-label="`${definition.name}`"
    v-if="selectedSex in (definition.layer_1 ?? {})"
    class="border-4 rounded-lg aspect-square bg-base-300 shadow-inner cursor-pointer hover:bg-base-100"
    :class="{
      'border-primary bg-base-100': isSelected,
    }"
  >
    <CanvasSpriteSheetPreview
      :definition="definition"
      :sex="selectedSex"
      :variant-idx="variantIdx"
      class="w-full h-full"
    />
  </div>
</template>
